// India states and cities data
// Comprehensive list including tier-1, tier-2, and tier-3 cities

export const INDIA_STATES = [
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chhattisgarh',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal',
    // Union Territories
    'Andaman and Nicobar Islands',
    'Chandigarh',
    'Dadra and Nagar Haveli and Daman and Diu',
    'Delhi',
    'Jammu and Kashmir',
    'Ladakh',
    'Lakshadweep',
    'Puducherry',
];

export const CITIES_BY_STATE = {
    'Andhra Pradesh': [
        // Tier-1
        'Visakhapatnam', 'Vijayawada', 'Guntur', 'Nellore', 'Kurnool',
        // Tier-2
        'Kakinada', 'Tirupati', 'Rajahmundry', 'Kadapa', 'Anantapur',
        'Vizianagaram', 'Eluru', 'Ongole', 'Nandyal', 'Chittoor',
        'Srikakulam', 'Bhimavaram', 'Proddatur', 'Narasaraopet',
        // Tier-3
        'Madanapalle', 'Rayachoty', 'Yemmiganur', 'Kadiri', 'Tadpatri',
        'Dharmavaram', 'Anakapalle', 'Sattenapalle', 'Pithapuram', 'Puttaparthi',
        'Srikalahasti', 'Chilakaluripet', 'Guntakal', 'Hindupur', 'Bapatla',
        'Chirala', 'Prakasam', 'Kavali', 'Markapur', 'Amaravati',
        'Mangalagiri', 'Tadepalligudem', 'Bhimavaram', 'Nuzvid', 'Vuyyuru',
        'Gudivada', 'Macherla', 'Gurazala', 'Dachepalli', 'Muppalla',
        'Rajampet', 'Kodada', 'Miryalaguda', 'Khammam', 'Palwancha',
    ],
    'Arunachal Pradesh': [
        // Tier-2
        'Itanagar', 'Naharlagun', 'Pasighat', 'Tezpur', 'Ziro',
        // Tier-3
        'Bomdila', 'Tezu', 'Aalo', 'Khonsa', 'Changlang',
        'Yingkiong', 'Seppa', 'Daporijo', 'Longding', 'Roing',
        'Tawang', 'Zemithang', 'Dirang', 'Kalaktang', 'Bhalukpong',
        'Mariyang', 'Mekong', 'Kolakunta', 'Pangin', 'Boleng',
    ],
    'Assam': [
        // Tier-1
        'Guwahati',
        // Tier-2
        'Dibrugarh', 'Silchar', 'Jorhat', 'Nagaon', 'Tinsukia',
        'Tezpur', 'Bongaigaon', 'Dhubri', 'Diphu', 'Karimganj',
        // Tier-3
        'Sibsagar', 'Goalpara', 'Golaghat', 'Barpeta', 'Lakhimpur',
        'Morigaon', 'Nalbari', 'Darrang', 'Udalguri', 'Kokrajhar',
        'Jalah', 'Bishwanath', 'Charaideo', 'Hojai', 'Biswanath',
        'Tamulpur', 'Bajali', 'Sarthebari', 'Sualkuchi', 'Marigaon',
    ],
    'Bihar': [
        // Tier-1
        'Patna', 'Gaya', 'Bhagalpur',
        // Tier-2
        'Muzaffarpur', 'Darbhanga', 'Arrah', 'Bihar Sharif', 'Motihari',
        'Bokaro', 'Begusarai', 'Chapra', 'Purnia', 'Samastipur',
        'Hajipur', 'Sasaram', 'Katihar', 'Bettiah', 'Bagaha',
        // Tier-3
        'Siwan', 'Barauni', 'Munger', 'Jehanabad', 'Bhabhua',
        'Kishanganj', 'Araria', 'Gopalganj', 'Madhubani', 'Supaul',
        'Khagaria', 'Saharsa', 'Madhepura', 'Sitamarhi', 'Sheikhpura',
        'Jamui', 'Lakhisarai', 'Sheohar', 'Vaishali', 'Nawada',
    ],
    'Chhattisgarh': [
        // Tier-2
        'Raipur', 'Bhilai', 'Bilaspur', 'Korba', 'Durg',
        'Rajnandgaon', 'Jagdalpur', 'Raigarh', 'Ambikapur', 'Dhamtari',
        // Tier-3
        'Mahasamund', 'Dongargarh', 'Kanker', 'Bemetara', 'Balod',
        'Baloda Bazar', 'Gariyaban', 'Janjgir', 'Sarangarh', 'Bhatapara',
        'Mungeli', 'Kawardha', 'Pandariya', 'Kumhari', 'Sakari',
        'Manendragarh', 'Chirmiri', 'Katghora', 'Pendra', 'Kondagaon',
    ],
    'Goa': [
        // Tier-2
        'Panaji', 'Margao', 'Vasco da Gama', 'Mapusa', 'Ponda',
        // Tier-3
        'Bicholim', 'Curchorem', 'Canacona', 'Cortalim', 'Quepem',
        'Sanquelim', 'Valpoi', 'Pernem', 'Sattari', 'Dharbandora',
    ],
    'Gujarat': [
        // Tier-1
        'Ahmedabad', 'Surat', 'Vadodara', 'Rajkot',
        // Tier-2
        'Bhavnagar', 'Jamnagar', 'Junagadh', 'Gandhinagar', 'Anand',
        'Mehsana', 'Navsari', 'Morbi', 'Nadiad', 'Surendranagar',
        'Bharuch', 'Amreli', 'Porbandar', 'Palanpur', 'Botad',
        'Valsad', 'Patan', 'Himmatnagar', 'Ankleshwar', 'Bharuch',
        // Tier-3
        'Godhra', 'Dahod', 'Banskantha', 'Sabarkantha', 'Aravalli',
        'Kheda', 'Mahisagar', 'Panchmahal', 'Chhota Udepur', 'Vadodara',
        'Narmada', 'Bharuch', 'Tapi', 'Dangs', 'Navsari',
        'Valsad', 'Daman', 'Diu', 'Veraval', 'Porbandar',
        'Somnath', 'Junagadh', 'Amreli', 'Bhavnagar', 'Botad',
        'Gandhidham', 'Bhuj', 'Anjar', 'Mandvi', 'Mandvi',
    ],
    'Haryana': [
        // Tier-1
        'Gurugram', 'Faridabad',
        // Tier-2
        'Panipat', 'Ambala', 'Yamunanagar', 'Rohtak', 'Hisar',
        'Karnal', 'Sonipat', 'Panchkula', 'Bhiwani', 'Sirsa',
        'Bahadurgarh', 'Jind', 'Kaithal', 'Rewari', 'Kurukshetra',
        // Tier-3
        'Hisar', 'Fatehabad', 'Tohana', 'Narwana', 'Jind',
        'Safidon', 'Gohana', 'Ganaur', 'Ratia', 'Nilokheri',
        'Indri', 'Nissing', 'Taraori', 'Mustafabad', 'Radaur',
        'Shahabad', 'Ladwa', 'Pehowa', 'Thanesar', 'Sampla',
    ],
    'Himachal Pradesh': [
        // Tier-2
        'Shimla', 'Solan', 'Dharamshala', 'Baddi', 'Kangra',
        'Kullu', 'Mandi', 'Una', 'Nahan', 'Palampur',
        // Tier-3
        'Bilaspur', 'Hamirpur', 'Chamba', 'Manali', 'Kullu',
        'Sarkaghat', 'Nagrota', 'Jogindernagar', 'Karsog', 'Chachiot',
        'Mandi', 'Sundernagar', 'Rohru', 'Theog', 'Kotkhai',
        'Jubbal', 'Narkanda', 'Chhota Shimla', 'Summer Hill', 'Sanjauli',
    ],
    'Jharkhand': [
        // Tier-2
        'Ranchi', 'Jamshedpur', 'Dhanbad', 'Bokaro', 'Deoghar',
        'Phusro', 'Hazaribagh', 'Giridih', 'Ramgarh', 'Medininagar',
        // Tier-3
        'Chaibasa', 'Dumka', 'Chirkunda', 'Koderma', 'Chatra',
        'Garhwa', 'Palamu', 'Latehar', 'Simdega', 'Gumla',
        'Lohardaga', 'Khunti', 'Ranchi', 'Bundu', 'Tamar',
        'Khunti', 'Murhu', 'Silli', 'Ichagarh', 'Kanke',
    ],
    'Karnataka': [
        // Tier-1
        'Bengaluru', 'Mysuru', 'Mangaluru',
        // Tier-2
        'Hubli', 'Dharwad', 'Belagavi', 'Ballari', 'Davangere',
        'Vijayapura', 'Shivamogga', 'Tumakuru', 'Bidar', 'Udupi',
        'Kolar', 'Hassan', 'Raichur', 'Chitradurga', 'Mandya',
        'Gadag', 'Yadgir', 'Bagalkot', 'Bijapur', 'Gulbarga',
        // Tier-3
        'Hassan', 'Chikmagalur', 'Shimoga', 'Kolar', 'Tumkur',
        'Chitradurga', 'Davanagere', 'Harapanahalli', 'Hosdurga', 'Holalkere',
        'Challakere', 'Hiriyur', 'Kudligi', 'Sandur', 'Bellary',
        'Kampli', 'Koppal', 'Gangavathi', 'Yelbarga', 'Kukanur',
    ],
    'Kerala': [
        // Tier-1
        'Thiruvananthapuram', 'Kochi', 'Kozhikode',
        // Tier-2
        'Thrissur', 'Kollam', 'Kannur', 'Alappuzha', 'Palakkad',
        'Malappuram', 'Kottayam', 'Pathanamthitta', 'Idukki', 'Wayanad',
        'Kasaragod', 'Ernakulam', 'Kollam', 'Thiruvananthapuram', 'Malappuram',
        // Tier-3
        'Kottayam', 'Pathanamthitta', 'Alappuzha', 'Kollam', 'Thiruvananthapuram',
        'Punalur', 'Kottarakkara', 'Neyyattinkara', 'Attingal', 'Varkala',
        'Chalakudy', 'Kunnamkulam', 'Guruvayur', 'Wadakkancherry', 'Mannarkkad',
        'Ottapalam', 'Cherpulassery', 'Palakkad', 'Alathur', 'Mannarkkad',
    ],
    'Madhya Pradesh': [
        // Tier-1
        'Bhopal', 'Indore',
        // Tier-2
        'Jabalpur', 'Gwalior', 'Ujjain', 'Sagar', 'Dewas',
        'Satna', 'Ratlam', 'Rewa', 'Katni', 'Singrauli',
        'Burhanpur', 'Khandwa', 'Bhind', 'Morena', 'Shivpuri',
        // Tier-3
        'Vidisha', 'Chhatarpur', 'Damoh', 'Sagar', 'Satna',
        'Panna', 'Rewa', 'Shahdol', 'Umaria', 'Katni',
        'Dhar', 'Mandsaur', 'Neemuch', 'Chittorgarh', 'Kota',
        'Baran', 'Jhalawar', 'Dungarpur', 'Banswara', 'Pratapgarh',
    ],
    'Maharashtra': [
        // Tier-1
        'Mumbai', 'Pune', 'Nagpur',
        // Tier-2
        'Nashik', 'Aurangabad', 'Solapur', 'Amravati', 'Kolhapur',
        'Thane', 'Nanded', 'Sangli', 'Latur', 'Jalgaon',
        'Akola', 'Chandrapur', 'Parbhani', 'Navi Mumbai', 'Bhiwandi',
        'Dhule', 'Ahmednagar', 'Malegaon', 'Kalyani', 'Miraj',
        'Vasai–Virar', 'Panvel', 'Ulhasnagar', 'Ambarnath', 'Badlapur',
        // Tier-3
        'Jalna', 'Latur', 'Osmanabad', 'Beed', 'Nandurbar',
        'Sindhudurg', 'Ratnagiri', 'Raigad', 'Palghar', 'Thane',
        'Gadchiroli', 'Gondia', 'Bhandara', 'Wardha', 'Yavatmal',
        'Washim', 'Hingoli', 'Buldhana', 'Aurangabad', 'Jalgaon',
    ],
    'Manipur': [
        // Tier-2
        'Imphal', 'Thoubal', 'Bishnupur', 'Churachandpur', 'Kakching',
        // Tier-3
        'Senapati', 'Ukhrul', 'Jiribam', 'Kangpokpi', 'Tengnoupal',
        'Chandel', 'Kamjong', 'Pherzawl', 'Noney', 'Tamenlong',
    ],
    'Meghalaya': [
        // Tier-2
        'Shillong', 'Tura', 'Jowai', 'Nongstoin', 'Resubelpara',
        // Tier-3
        'Nongpoh', 'Baghmara', 'Mairang', 'Williamnagar', 'Jaintia Hills',
        'East Khasi Hills', 'West Khasi Hills', 'Ri Bhoi', 'South Garo Hills', 'South West Garo Hills',
    ],
    'Mizoram': [
        // Tier-2
        'Aizawl', 'Lunglei', 'Saiha', 'Champhai', 'Serchhip',
        // Tier-3
        'Kolasib', 'Lawngtlai', 'Mamit', 'Khawzawl', 'Hnahthial',
        'Saitual', 'Lunglei', 'Vaihang', 'Chawngte', 'West Phaileng',
    ],
    'Nagaland': [
        // Tier-2
        'Kohima', 'Dimapur', 'Mokokchung', 'Tuensang', 'Wokha',
        // Tier-3
        'Zunheboto', 'Mon', 'Phek', 'Kiphire', 'Longleng',
        'Peren', 'Noklak', 'Tseminyu', 'Chozuba', 'Pughoboto',
    ],
    'Odisha': [
        // Tier-1
        'Bhubaneswar', 'Cuttack',
        // Tier-2
        'Rourkela', 'Brahmapur', 'Sambalpur', 'Puri', 'Balasore',
        'Bhadrak', 'Baripada', 'Jharsuguda', 'Bargarh', 'Angul',
        // Tier-3
        'Dhenkanal', 'Paradip', 'Jajpur', 'Kendujhar', 'Berhampur',
        'Balangir', 'Sundergarh', 'Sambalpur', 'Deogarh', 'Anugul',
        'Boudh', 'Gajapati', 'Kalahandi', 'Kandhamal', 'Koraput',
        'Malkangiri', 'Mayurbhanj', 'Nayagarh', 'Nuapada', 'Puri',
    ],
    'Punjab': [
        // Tier-1
        'Ludhiana', 'Amritsar', 'Jalandhar',
        // Tier-2
        'Patiala', 'Bathinda', 'Mohali', 'Pathankot', 'Hoshiarpur',
        'Batala', 'Gurdaspur', 'Firozpur', 'Moga', 'Muktsar',
        // Tier-3
        'Zirakpur', 'Ropar', 'Phagwara', 'Kapurthala', 'Nakodar',
        'Moga', 'Sangrur', 'Malerkotla', 'Barnala', 'Faridkot',
        'Firozpur', 'Moga', 'Muktsar', 'Pathankot', 'Gurdaspur',
    ],
    'Rajasthan': [
        // Tier-1
        'Jaipur', 'Jodhpur', 'Kota',
        // Tier-2
        'Bikaner', 'Ajmer', 'Udaipur', 'Bhilwara', 'Alwar',
        'Bharatpur', 'Sikar', 'Pali', 'Barmer', 'Hanumangarh',
        'Sri Ganganagar', 'Chittorgarh', 'Nagaur', 'Tonk', 'Dausa',
        // Tier-3
        'Baran', 'Jhalawar', 'Dungarpur', 'Banswara', 'Pratapgarh',
        'Rajsamand', 'Kumbhalgarh', 'Nawalgarh', 'Jhunjhunu', 'Churu',
        'Fatehpur', 'Sardarshahar', 'Nohar', 'Bhadra', 'Hanumangarh',
    ],
    'Sikkim': [
        // Tier-2
        'Gangtok', 'Namchi', 'Gyalshing', 'Mangan', 'Jorethang',
        // Tier-3
        'Rangpo', 'Singtam', 'Ravangla', 'Namchi', 'Jorethang',
        'Soreng', 'Kaluk', 'Pelling', 'Yuksam', 'Gyalshing',
    ],
    'Tamil Nadu': [
        // Tier-1
        'Chennai', 'Coimbatore', 'Madurai',
        // Tier-2
        'Tiruchirappalli', 'Salem', 'Tirunelveli', 'Tirupur', 'Erode',
        'Vellore', 'Thoothukudi', 'Dindigul', 'Thanjavur', 'Ranipet',
        'Sivakasi', 'Karur', 'Udhagamandalam', 'Hosur', 'Nagercoil',
        // Tier-3
        'Kanchipuram', 'Kumbakonam', 'Cuddalore', 'Ambattur', 'Tiruvannamalai',
        'Pollachi', 'Tirupathi', 'Nellai', 'Kanyakumari', 'Ooty',
        'Coonoor', 'Kodaikanal', 'Yercaud', 'Hogenakkal', 'Valliyur',
    ],
    'Telangana': [
        // Tier-1
        'Hyderabad',
        // Tier-2
        'Warangal', 'Nizamabad', 'Khammam', 'Karimnagar', 'Ramagundam',
        'Mahbubnagar', 'Nalgonda', 'Adilabad', 'Suryapet', 'Miryalaguda',
        // Tier-3
        'Jadcherla', 'Mancherial', 'Siddipet', 'Kothagudem', 'Sircilla',
        'Kamareddy', 'Jangaon', 'Bhoothpur', 'Thorrur',
    ],
    'Tripura': [
        // Tier-2
        'Agartala', 'Sabroom', 'Udaipur', 'Dharmanagar', 'Kailashahar',
        // Tier-3
        'Belonia', 'Khowai', 'Ambassa', 'Ranirbazar', 'Sabroom',
        'Bishalgarh', 'Teliamura', 'Kailasahar', 'Khowai', 'Amarpur',
    ],
    'Uttar Pradesh': [
        // Tier-1
        'Lucknow', 'Kanpur', 'Agra', 'Ghaziabad', 'Meerut',
        // Tier-2
        'Varanasi', 'Prayagraj', 'Bareilly', 'Aligarh', 'Moradabad',
        'Noida', 'Saharanpur', 'Gorakhpur', 'Faizabad', 'Mathura',
        'Jhansi', 'Muzaffarnagar', 'Firozabad', 'Loni', 'Budaun',
        // Tier-3
        'Rampur', 'Shahjahanpur', 'Hapur', 'Unnao', 'Sitapur',
        'Raebareli', 'Orai', 'Bulandshahr', 'Bahraich', 'Sultanpur',
        'Azamgarh', 'Mirzapur', 'Etawah', 'Fatehpur', 'Sultanpur',
    ],
    'Uttarakhand': [
        // Tier-2
        'Dehradun', 'Haridwar', 'Roorkee', 'Haldwani', 'Rudrapur',
        'Kashipur', 'Rishikesh', 'Kotdwar', 'Pithoragarh', 'Almora',
        // Tier-3
        'Mussoorie', 'Nainital', 'Ramnagar', 'Kashipur', 'Khatima',
        'Laksar', 'Bahadarabad', 'Dhandera', 'Jwalapur', 'Kashipur',
    ],
    'West Bengal': [
        // Tier-1
        'Kolkata', 'Asansol', 'Siliguri',
        // Tier-2
        'Durgapur', 'Bardhaman', 'Malda', 'Baharampur', 'Habra',
        'Kharagpur', 'Shantipur', 'Dankuni', 'Dhulian', 'Ranaghat',
        // Tier-3
        'Haldia', 'Raiganj', 'Krishnanagar', 'Howrah', 'Darjeeling',
        'Cooch Behar', 'Jalpaiguri', 'Baharampur', 'Krishnanagar', 'Berhampore',
    ],
    // Union Territories
    'Andaman and Nicobar Islands': [
        // Tier-2
        'Port Blair', 'Diglipur', 'Rangat', 'Mayabunder', 'Car Nicobar',
        // Tier-3
        'Hut Bay', 'Little Andaman', 'Great Nicobar', 'Neil Island', 'Havelock Island',
    ],
    'Chandigarh': [
        // Tier-2
        'Chandigarh',
        // Tier-3
        'Mohali', 'Panchkula', 'Zirakpur', 'Kharar', 'Kalka',
    ],
    'Dadra and Nagar Haveli and Daman and Diu': [
        // Tier-2
        'Silvassa', 'Daman', 'Diu',
        // Tier-3
        'Dadra', 'Daman', 'Diu', 'Kachigaon', 'Samarvarni',
    ],
    'Delhi': [
        // Tier-1
        'New Delhi',
        // Tier-2
        'North Delhi', 'South Delhi', 'East Delhi', 'West Delhi',
        'Dwarka', 'Rohini', 'Janakpuri', 'Lajpat Nagar', 'Saket',
        // Tier-3
        'Nehru Place', 'Connaught Place', 'Karol Bagh', 'Sarojini Nagar', 'Vasant Kunj',
        'Pitampura', 'Shahdara', 'Vivek Vihar', 'Paharganj', 'Chandni Chowk',
    ],
    'Jammu and Kashmir': [
        // Tier-2
        'Srinagar', 'Jammu', 'Anantnag', 'Baramulla', 'Sopore',
        // Tier-3
        'Kulgam', 'Punch', 'Rajouri', 'Kathua', 'Udhampur',
        'Kishtwar', 'Ramban', 'Doda', 'Poonch', 'Budgam',
    ],
    'Ladakh': [
        // Tier-3
        'Leh', 'Kargil', 'Khaltsi', 'Nubra', 'Zanskar',
    ],
    'Lakshadweep': [
        // Tier-3
        'Kavaratti', 'Agatti', 'Amini', 'Minicoy', 'Andrott',
    ],
    'Puducherry': [
        // Tier-2
        'Puducherry', 'Karaikal', 'Mahe', 'Yanam',
        // Tier-3
        'Ozhukarai', 'Villianur', 'Bahour', 'Nettapakkam', 'Mannadipet',
    ],
};
